import {
  FilterFn,
  getCoreRowModel,
  getExpandedRowModel,
  useReactTable,
  type ColumnDef,
  type ExpandedState,
  type OnChangeFn,
} from "@tanstack/react-table";

import { OrganizationNode } from "../types/commonTypes";

interface GetManagementTableDefinitionProps {
  treeData: OrganizationNode[];
  columns: ColumnDef<OrganizationNode>[];
  expanded: ExpandedState;
  setExpanded: OnChangeFn<ExpandedState>;
}

const fuzzyFilter: FilterFn<any> = (row, columnId, value, addMeta) => {
  const itemValue = row.getValue(columnId);
  if (itemValue == null) {
    return false;
  }
  const searchStr = String(value).toLowerCase();
  const itemStr = String(itemValue).toLowerCase();
  return itemStr.includes(searchStr);
};

export const useGetManagementTableDefinition = ({
  treeData,
  columns,
  expanded,
  setExpanded,
}: GetManagementTableDefinitionProps) => {
  const table = useReactTable<OrganizationNode>({
    data: treeData,
    columns,
    state: {
      expanded,
    },
    onExpandedChange: setExpanded,
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    filterFns: {
      fuzzy: fuzzyFilter,
    },
    getSubRows: (row) => row.children ?? [],
  });

  return { table };
};
